// DashboardColorContext.tsx
import { createContext, useContext } from "react";

export const DashboardColorContext = createContext<string>("#000");

export const useDashboardColor = () => useContext(DashboardColorContext);
